import { createApp } from "vue"
import App from "./App.vue"
import { VueReCaptcha } from "vue-recaptcha-v3"
import router from "./router/index"
import "./assets/scss/style.scss"
import { createPinia } from "pinia"
import { setupI18n } from "./i18n"

const init = async () => {
  const app = createApp(App)

  app.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_CLIENT_CODE || "",
    loaderOptions: {}
  })

  const pinia = createPinia()

  const i18n = await setupI18n()

  app.use(pinia).use(router).use(i18n).mount("#app")

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty("--vh", window.innerHeight * 0.01 + "px")
  }

  window.addEventListener("resize", appHeight)
  appHeight()
}

init()
